import { useState } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import AlertDialog from 'components/AlertDialog'
import { ReactComponent as ButtonLoading } from 'icons/loading2.svg'
import * as FA from 'react-icons/fa'
import { DateTime } from 'luxon'

import {
  Container,
  InfoText,
  Row,
  Button
} from './styles'

export default function Record ({
  data: record,
  onDelete: handleDelete
}) {
  const [showAlertDialog, setShowAlertDialog] = useState (false)
  const [deleting, setDeleting] = useState (false)
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const deleteRecord = async () => {
    setDeleting (true)
    try {
      await cutileiApi.delete (`/records/${record.id}`, requestConfig)
      setDeleting (false)
      handleDelete (record)
    } catch (error) {
      setDeleting (false)
      logApiError (error)
    }
  }

  const toggleAlertDialog = () => setShowAlertDialog (!showAlertDialog)

  return (
    <Container>
      <InfoText style={{justifySelf: 'flex-start'}}>
        {DateTime.fromISO (record.created_at).toFormat ('dd/MM/yyyy - HH:mm:ss')}
      </InfoText>
      <InfoText>
        {record.description}
      </InfoText>
      <Row style={{justifySelf: 'flex-end'}}>
        <Button onClick={toggleAlertDialog}>
          {deleting ? (
            <ButtonLoading style={{margin: 0}}/>
          ) : (
            <FA.FaTrash color='#FF3939' size={16}/>
          )}
        </Button>
      </Row>
      <AlertDialog
        visible={showAlertDialog}
        title='Atenção!'
        message='Deseja realmente excluir este registro?'
        confirmText='Sim'
        cancelText='Não'
        onConfirm={deleteRecord}
        onClose={toggleAlertDialog}
        dangerous
      />
    </Container>
  )
}
